import React from 'react'
import useDidMountEffect from '../../../../../hooks/useDidMountEffect/useDidMountEffect'

import InputSelect from '../../../../../components/modalComponents/InputSelect'
import {validarCreateSolicitudBeneficioAPI,
} from "../../../../../consumers/backendApisUrls";
import BeneficioItems from "../components/BeneficioItems";
import {useManagePostRequest} from "../../../../../hooks/useManagePostRequest/useManagePostRequest";

const SeleccionarBeneficios = ({
                                   sendCurrentStep,
                                   setSendCurrentStep,
                                   componentStep,
                                   KEYS,
                                   selectProps,
                                   SECTION_NAME,
                                   formValues,
                                   modalData,
                                   setModalData,
                                   getPayloadToSubmitItems,
                                   getPayloadToGetItems
                               }) => {
    const [executeManagePost] = useManagePostRequest();

    useDidMountEffect(() => {
        if (sendCurrentStep?.step === componentStep && sendCurrentStep?.isSent) {
            handleSubmit();
        }
    }, [sendCurrentStep])

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();

        let payload = getPayloadToSubmitItems();

        const api = validarCreateSolicitudBeneficioAPI();
        await executeManagePost(api, payload, ({data}) => handleSubmitCallback(data), false, null, true);
    }

    const handleSubmitCallback = async (responseData) => {
        setSendCurrentStep(lastData => ({...lastData, isSent: false, isSaved: true}));
    }

    return (
        <>
            {/*<div className="displayFlexWrap">*/}
            {/*    <Div>*/}
            {/*        <InputSelect*/}
            {/*            label="Campaña"*/}
            {/*            {...selectProps(KEYS.idCampanaBeneficio)}*/}
            {/*            sectionName={SECTION_NAME}*/}
            {/*            isDisabled={true}*/}
            {/*            isRequired={false}*/}
            {/*            hasValidationMessage={false}*/}
            {/*            placeholder={"Seleccionar Campaña"}*/}
            {/*        />*/}
            {/*    </Div>*/}
            {/*</div>*/}

            <div className="d-flex justify-content-between">
                <div className="d-flex justify-content-start mb-1">

                    <div style={{width: '300px', display: 'none'}} className={"mr-1"}>
                        <InputSelect
                            label=''
                            {...selectProps(KEYS.IdTipoBeneficioItem)}
                            sectionName={SECTION_NAME}
                            isDisabled={false}
                            isRequired={false}
                            hasValidationMessage={false}
                            placeholder={"Buscar por Tipo"}
                            direction={""}
                        />
                    </div>

                    <div style={{width: '300px', display: 'none' }}>
                        <InputSelect
                            label=''
                            {...selectProps(KEYS.IdUbicacionBeneficioItem)}
                            sectionName={SECTION_NAME}
                            isDisabled={false}
                            isRequired={false}
                            hasValidationMessage={false}
                            placeholder={"Buscar por Ubicación"}
                            direction={""}         
                        />
                    </div>

                </div>
                <div>
                    <p style={{fontWeight: 600}}>S/. {modalData?.currentTotal?.toFixed(2)} de
                        S/. {modalData?.campanaBeneficioItemsToSolicitarResponse?.Tope?.toFixed(2)}</p>
                </div>
            </div>

            <BeneficioItems modalData={modalData} setModalData={setModalData} formValues={formValues} KEYS={KEYS}/>

            {modalData?.campanaBeneficioItemsToSolicitarResponse?.LineamientosUrl &&
                <div className="mt-3 d-flex justify-content-start">
                    <div>
                        <p>Ver Lineamientos <a
                            href={modalData?.campanaBeneficioItemsToSolicitarResponse?.LineamientosUrl}
                            target="_blank">Aquí</a></p>
                    </div>
                </div>
            }
        </>
    )
}

export default SeleccionarBeneficios;